"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("../../core");
var lang_1 = require("../../core/lang");
var i_st_1 = require("../../core/st/interface/i$st");
// matches when no route matches (not even partially!), basically like HTTP ERROR 404 NOT FOUND behaviour
exports.PATH_WILDCARD = "*";
// matches when no path is given, like: /, /#, /#/
exports.PATH_START = "";
exports.DEFAULT_ROUTE_CACHE_GROUP = 'main';
if (!core_1.st.router) {
    var PATH_SEP_1 = "/";
    var PATH_PARAM_PREFIX_1 = ":";
    var PATH_TOKEN_MISSING_1 = "TOKEN_MISSING:ACTUAL_PATH_LONGER";
    core_1.st.router = {
        match: {},
        // necessary for operations to act on location change
        ON_LOCATION_CHANGE_HANDLERS: [],
        // necessary for operations that belong to .match being validated already
        ON_AFTER_MATCH_HANDLERS: [],
        tokenizedActualPath: [],
        prefix: '#/',
        enabled: false,
        paramsChanged: false,
        ON_AFTER_CACHE_GROUP_CHANGE_HANDLERS: [],
        activeRouteCacheGroup: exports.DEFAULT_ROUTE_CACHE_GROUP,
        activeLinkClass: ['active'],
        addOnAfterCacheGroupChangeHandler: function (handler) {
            core_1.st.router.ON_AFTER_CACHE_GROUP_CHANGE_HANDLERS.push(handler);
        },
        removeOnAfterCacheGroupChangeHandler: function (handler) {
            var index = core_1.st.router.ON_AFTER_CACHE_GROUP_CHANGE_HANDLERS.indexOf(handler);
            if (index > -1) {
                core_1.st.router.ON_AFTER_CACHE_GROUP_CHANGE_HANDLERS.splice(index, 1);
            }
        },
        callOnAfterCacheGroupChangeHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
            var _i, _a, handler;
            return __generator(this, function (_b) {
                for (_i = 0, _a = core_1.st.router.ON_AFTER_CACHE_GROUP_CHANGE_HANDLERS; _i < _a.length; _i++) {
                    handler = _a[_i];
                    handler();
                }
                return [2 /*return*/];
            });
        }); },
        addOnAfterMatchHandler: function (handler) {
            core_1.st.router.ON_AFTER_MATCH_HANDLERS.push(handler);
        },
        removeOnAfterMatchHandler: function (handler) {
            var index = core_1.st.router.ON_AFTER_MATCH_HANDLERS.indexOf(handler);
            if (index > -1) {
                core_1.st.router.ON_AFTER_MATCH_HANDLERS.splice(index, 1);
            }
        },
        callOnAfterMatchHandlers: function () { return __awaiter(void 0, void 0, void 0, function () {
            var _i, _a, handler, _b, _c, cmp;
            return __generator(this, function (_d) {
                for (_i = 0, _a = core_1.st.router.ON_AFTER_MATCH_HANDLERS; _i < _a.length; _i++) {
                    handler = _a[_i];
                    handler();
                }
                if (core_1.st.router.paramsChanged) {
                    for (_b = 0, _c = core_1.st[i_st_1.GlobalCache.COMPONENT_INSTANCES]; _b < _c.length; _b++) {
                        cmp = _c[_b];
                        if (typeof cmp.onRouteParamsChanged === lang_1.TYPE_FUNCTION) {
                            cmp.onRouteParamsChanged(core_1.st.router.match.params);
                        }
                    }
                }
                return [2 /*return*/];
            });
        }); },
        addOnLocationChangeHandler: function (handler) {
            core_1.st.router.ON_LOCATION_CHANGE_HANDLERS.push(handler);
        },
        removeOnLocationChangeHandler: function (handler) {
            var index = core_1.st.router.ON_LOCATION_CHANGE_HANDLERS.indexOf(handler);
            if (index > -1) {
                core_1.st.router.ON_LOCATION_CHANGE_HANDLERS.splice(index, 1);
            }
        },
        callOnLocationChangeHandlers: function () {
            core_1.st.router.match = {};
            for (var _i = 0, _a = core_1.st.router.ON_LOCATION_CHANGE_HANDLERS; _i < _a.length; _i++) {
                var handler = _a[_i];
                handler();
            }
        },
        tokenize: function (urlPath) {
            return urlPath.split(PATH_SEP_1);
        },
        doMatch: function (tokenizedMatchPath, path) {
            // local temp. match
            var match = {
                isExact: true,
                isPartial: false,
                params: {},
                paths: [],
                path: path
            };
            var maxLength = tokenizedMatchPath.length > core_1.st.router.tokenizedActualPath.length ?
                tokenizedMatchPath.length : core_1.st.router.tokenizedActualPath.length;
            for (var i = 0; i < maxLength; i++) {
                // allow for "" to be a valid token, but not undefined
                var pathToken = typeof tokenizedMatchPath[i] !== lang_1.TYPE_UNDEFINED ?
                    tokenizedMatchPath[i] : PATH_TOKEN_MISSING_1;
                // looks like a parameter because it starts with ":"
                if (pathToken.startsWith(PATH_PARAM_PREFIX_1)) {
                    // cut away first char (":")
                    var paramName = pathToken.substring(1);
                    if (match.params[paramName] !== core_1.st.router.tokenizedActualPath[i]) {
                        core_1.st.router.paramsChanged = true;
                        // casts intrinsically based on the string syntax ("0.012" -> float number, "true" -> true etc.)
                        //let parameter = castIntrinsic(st.router.tokenizedActualPath[i]);
                        var parameter = core_1.st.router.tokenizedActualPath[i];
                        if (typeof parameter === lang_1.TYPE_STRING) {
                            //unescape url parameter if string
                            parameter = unescape(parameter);
                        }
                        match.params[paramName] = parameter;
                    }
                }
                else if (!core_1.st.router.tokenizedActualPath[i] && tokenizedMatchPath[i]) {
                    match.isExact = false;
                    match.isPartial = false;
                    // e.g. match path: "blog/page/9" vs. actual path: "blog"
                    break;
                }
                else {
                    // match the actual path token with the candidates token at the same position
                    if (typeof core_1.st.router.tokenizedActualPath[i] != lang_1.TYPE_UNDEFINED &&
                        pathToken === core_1.st.router.tokenizedActualPath[i]) {
                        match.isPartial = true;
                    }
                    else {
                        // can't be an exact match anymore, because one position didn't match
                        match.isExact = false;
                    }
                }
            }
            if (match.isPartial) {
                //partial only if path is smaller than actual length
                match.isPartial = tokenizedMatchPath.length < core_1.st.router.tokenizedActualPath.length;
            }
            var queryParams = core_1.st.router.getQueryParams();
            for (var key in queryParams) {
                match.params[key] = queryParams[key];
            }
            if (match.isPartial || match.isExact) {
                return match;
            }
        },
        getQueryParams: function () {
            var locationSearchParams = {};
            var queryString = location.href.split('?')[1];
            if (!queryString) {
                return {};
            }
            decodeURIComponent(queryString)
                .split(/&/g)
                .forEach(function (assignment) {
                var assignmentSplit = assignment.split('=');
                locationSearchParams[assignmentSplit[0]] = assignmentSplit[1];
            });
            return locationSearchParams;
        },
        // for: /#/home/foo, #home/foo, /home/foo
        // always return: home/foo
        getUrlPath: function (pathnameOrHash) {
            // pathname always starts with "/" and hash always with "#" -> cut em out
            var urlPath = pathnameOrHash.substring(1);
            // in case of /#/foo
            if (urlPath.indexOf(PATH_SEP_1) === 0) {
                urlPath = urlPath.substring(1);
            }
            // strip leading /
            urlPath = core_1.st.router.removeTrailingSep(urlPath);
            return urlPath;
        },
        removeTrailingSep: function (url) {
            return url[url.length - 1] === PATH_SEP_1 ? url.substring(0, url.length - 1) : url;
        },
        createMatcher: function (matchPath, onMatch, onMismatch) {
            // one-time closure cache, tokenize the path 1x
            var tokenizedPaths = [];
            var nonTokenizedPaths = [];
            if (!Array.isArray(matchPath)) {
                matchPath = [matchPath];
            }
            for (var _i = 0, matchPath_1 = matchPath; _i < matchPath_1.length; _i++) {
                var path = matchPath_1[_i];
                tokenizedPaths.push(core_1.st.router.tokenize(core_1.st.router.removeTrailingSep(path)));
                nonTokenizedPaths.push(path);
            }
            var matchAndNotify = function (tokenizedPath, nonTokenizedPath) {
                core_1.st.router.initMatch();
                for (var i = 0; i < tokenizedPath.length; i++) {
                    var match = core_1.st.router.doMatch(tokenizedPath[i], nonTokenizedPath[i]);
                    if (match) {
                        core_1.st.router.updateMatch(match, nonTokenizedPaths);
                        onMatch(nonTokenizedPath[i], match);
                    }
                    else {
                        onMismatch(nonTokenizedPath[i]);
                    }
                }
            };
            return function () {
                matchAndNotify(tokenizedPaths, nonTokenizedPaths);
            };
        },
        updateMatch: function (match, nonTokenizedPaths) {
            for (var _i = 0, nonTokenizedPaths_1 = nonTokenizedPaths; _i < nonTokenizedPaths_1.length; _i++) {
                var nonTokenizedPath = nonTokenizedPaths_1[_i];
                core_1.st.router.match[nonTokenizedPath] = match;
            }
        },
        initMatch: function () {
            if (!core_1.st.router.match) {
                core_1.st.router.match = {};
            }
        },
        tokenizeActualPath: function () {
            // cache tokenized actual path
            core_1.st.router.tokenizedActualPath = core_1.st.router.tokenize(core_1.st.router.getUrlPath(window.location.hash || window.location.pathname));
        },
        onLocationChange: function () {
            // early return if there are no registered location change handlers
            if (!core_1.st.router.ON_LOCATION_CHANGE_HANDLERS.length)
                return;
            // called initially AND when location changes
            // reset match
            delete core_1.st.router.match;
            core_1.st.router.paramsChanged = false;
            core_1.st.router.tokenizeActualPath();
            // run matchers
            core_1.st.router.callOnLocationChangeHandlers();
            core_1.st.router.callOnAfterMatchHandlers();
            core_1.st.router.callOnAfterCacheGroupChangeHandler();
            if (!Object.keys(core_1.st.router.match).length) {
                core_1.st.router.tokenizedActualPath = [exports.PATH_WILDCARD];
                core_1.st.router.callOnLocationChangeHandlers();
                core_1.st.router.callOnAfterMatchHandlers();
                core_1.st.router.callOnAfterCacheGroupChangeHandler();
                if (!core_1.st.router.match) {
                    if (process.env.NODE_ENV === 'development') {
                        core_1.st.error('Not a single route provided via <Route> or <RouteList> did match.');
                    }
                }
            }
        },
        enable: function () {
            if (!core_1.st.router.enabled) {
                core_1.st.router.enabled = true;
                core_1.st.router.onLocationChange();
                if (!window.onpopstate) {
                    window.onpopstate = core_1.st.router.onLocationChange;
                }
            }
        },
        materialize: function (route, params) {
            if (!params)
                return route;
            // we take a route like /blog/:post-id and params like { "post-id": 5 }
            // and produce /blog/5 to transform it into a navigatable URL again
            for (var param in params) {
                route = route.replace(PATH_PARAM_PREFIX_1 + param, params[param]);
            }
            return route;
        },
        navigate: function (route, params) {
            window.location.href = core_1.st.router.prefix + core_1.st.router.materialize(route, params);
        }
    };
    // allows st.route = { ... } to actually change the route
    // and st.route to actually return the latest match
    Object.defineProperty(core_1.st, 'route', {
        set: function (value) {
            core_1.st.router.navigate(value.path, value.params);
        },
        get: function () {
            var matchers = Object.values(core_1.st.router.match);
            var exactMatch = matchers.find(function (m) { return m.isExact; });
            if (exactMatch) {
                return exactMatch;
            }
            if (matchers.length) {
                return matchers[0];
            }
        }
    });
}
else {
    if (process.env.NODE_ENV === 'development') {
        core_1.st.warn('Module router is loaded twice. Check for duplicate framework import!');
    }
}
//# sourceMappingURL=router.js.map